import {Component, OnInit, Inject, ViewChild, ElementRef, HostListener} from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';
import { emailValidator } from '../../validators/custom-email-validator';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {
  popupTitle = 'teamManagement.deleteConfirmation';
  popupBodyText = 'teamManagement.areYouSureDoYouWantToDelete';
  selectedDate;
  currentDate:string = '';
  errorText:string = '';
  okButton='teamManagement.ok';
  cancelButton='scheduleRotation.cancel';
  @ViewChild('formDialog') formDialog: ElementRef;
  clickedOutside = false;
  showAlert = false;
  showCancelButton = true;
  showPopupTitle = true;
  emailControl = new UntypedFormControl('', [Validators.required, emailValidator]);

  constructor(public readonly dialogRef: MatDialogRef<ConfirmDialogComponent>,
              public readonly translate: TranslateService,
              @Inject(MAT_DIALOG_DATA) public readonly data: any,
              private dateAdapter: DateAdapter<Date>) {
                if(data?.key === 'save'){
                  this.dateAdapter.setLocale(this.translate.currentLang);
                }
  }

  ngOnInit() {
    this.updateProperty();
  }

  updateProperty() {
    if (this.data) {
      this.clickedOutside=false;
      this.showAlert = !!this.data.showAlert;
      this.popupTitle = this.data.popupTitle || this.popupTitle;
      this.popupBodyText = this.data.popupBodyText ?? this.popupBodyText;
      this.okButton=this.data.saveButton || this.okButton;
      this.cancelButton=this.data.cancelButton || this.cancelButton;
      this.showCancelButton = !this.data.hideCancelButton;
      this.showPopupTitle = this.data.showPopupTitle !== false;
      if (this.data.key === 'email') {
        this.emailControl.setValue(this.data.emailAddress || '');
        this.emailControl.markAsPristine();
        this.emailControl.markAsUntouched();
      }
    }
  }

  close() {
    this.dialogRef.close({action: 'close'});
  }
  closeWindow()
  {
    this.dialogRef.close({action: 'closeWindow'});
  }

  confirm(option?:string) {
    this.formatDate();
    if (this.data?.key === 'email') {
      this.emailControl.markAsTouched();
      this.emailControl.updateValueAndValidity();
      if (this.emailControl.invalid) {
        return;
      }
      this.dialogRef.close({action: 'confirm', data: { option, emailAddress: this.emailControl.value?.trim() }});
      return;
    }
    if((this.errorText === ''|| this.selectedDate === undefined) && !this.data?.overrideSelectedDate)
    {
      this.dialogRef.close({action: 'confirm',data:{option,selectedDate:this.selectedDate}});
    }
    if(this.data?.overrideSelectedDate) {
      this.dialogRef.close({action: 'confirm',data:{option,overrideSelectedDate:this.data.overrideSelectedDate}});
    }
  }

  checkDate(){
    this.errorText = '';
    const startDate = new Date(this.data.dateSelected)
    startDate.setHours(0,0,0);
    if( this.data.dateSelected && this.selectedDate < startDate ){
      this.errorText = this.translate.instant('scheduleRotation.endDateCannotBeLessThanStartDate');
    }
  }
  formatDate(){
    if(this.selectedDate){
      const month = (this.selectedDate.getMonth()+1).toString().length !==2 ? `0${(this.selectedDate.getMonth()+1)}`:(this.selectedDate.getMonth()+1);
      const days = this.selectedDate.getDate().toString().length <2 ? `0${this.selectedDate.getDate()}`:this.selectedDate.getDate();
      this.selectedDate = `${this.selectedDate.getFullYear()}-${month}-${days}`;
    }
  }
  getTranslation(value){
    return value ? this.translate.instant(`servicePersonnel.${value.toLowerCase()}`) : value;
  }

  shouldShowEmailError() {
    return this.data?.key === 'email' && this.emailControl.invalid && (this.emailControl.touched || this.emailControl.dirty);
  }

  isConfirmDisabled() {
    return this.data?.key === 'email' ? this.emailControl.invalid : this.errorText.length > 0;
  }

  @HostListener("document:click", ['$event.target'])
  showMessage(event)
  {    
    if (!this.formDialog.nativeElement.contains(event) )
    {
      if( this.data?.clicked) {
        this.data.clicked=false;
      }
      else{
        this.clickedOutside=true;
      }
    }
  }
}
